/* Frantoio di Assisi — comportamenti dell'area COMMERCIO (scheda prodotto, collezione, carrello, account).
   Complementa assets/theme.js (che gestisce varianti, galleria, carrello laterale) senza duplicarlo.
   Si re-inizializza con shopify:section:load. */
(function () {
  'use strict';
  if (window.FACommerce) return;
  window.FACommerce = true;

  function $all(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  function money(cents) {
    var FA = window.FA || {};
    try { return new Intl.NumberFormat(FA.locale || 'it', { style: 'currency', currency: FA.currency || 'EUR' }).format(cents / 100); }
    catch (e) { return (cents / 100).toFixed(2).replace('.', ',') + ' €'; }
  }
  function once(el, key) { if (el['_fa' + key]) return false; el['_fa' + key] = true; return true; }

  /* Pulsanti +/− accanto ai campi quantità */
  function initSteppers(root) {
    $all('[data-fa-step]', root).forEach(function (b) {
      if (!once(b, 'step')) return;
      b.addEventListener('click', function () {
        var input = b.parentNode.querySelector('input[type="number"]'); if (!input) return;
        var min = input.min !== '' ? parseInt(input.min, 10) : 0, max = input.max !== '' ? parseInt(input.max, 10) : 999;
        var v = (parseInt(input.value, 10) || 0) + parseInt(b.dataset.faStep, 10);
        input.value = Math.max(min, Math.min(max, v));
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
  }

  /* Moduli che si inviano da soli (filtri collezione, quantità carrello) */
  function initAutosubmit(root) {
    $all('form[data-fa-autosubmit]', root).forEach(function (form) {
      if (!once(form, 'auto')) return;
      var t;
      form.addEventListener('change', function (e) {
        if (e.target.tagName === 'TEXTAREA') return;
        clearTimeout(t);
        var delay = e.target.type === 'number' ? 700 : 150;
        t = setTimeout(function () {
          form.classList.add('is-loading');
          // Non inviare i campi prezzo vuoti, così l'URL resta pulito
          $all('input[type="number"]', form).forEach(function (i) { if (i.value === '' && i.name.indexOf('filter.') === 0) i.disabled = true; });
          form.submit();
        }, delay);
      });
    });
  }

  /* Scheda prodotto: prezzo nella barra fissa e prezzi dei piani di abbonamento per la variante scelta */
  function initProductExtras(root) {
    $all('[data-fa-product]', root).forEach(function (el) {
      if (!once(el, 'extras')) return;
      var dataEl = el.querySelector('[data-fa-variants]'); if (!dataEl) return;
      var variants; try { variants = JSON.parse(dataEl.textContent || '[]'); } catch (e) { return; }
      var section = el.closest('.fa-section') || document;
      var idInput = el.querySelector('input[name="id"]');
      function sync() {
        if (!idInput) return;
        var id = parseInt(idInput.value, 10);
        var v = variants.find(function (x) { return x.id === id; }); if (!v) return;
        $all('[data-fa-sticky-price]', section).forEach(function (p) { p.textContent = money(v.price); });
        $all('[data-fa-plan-price=""]', el).forEach(function (p) { p.textContent = money(v.price); });
        var plans = v.plans || {};
        $all('[data-fa-plan]', el).forEach(function (label) {
          var pid = label.dataset.faPlan, has = Object.prototype.hasOwnProperty.call(plans, pid);
          label.hidden = !has;
          var input = label.querySelector('input');
          if (!has && input && input.checked) { input.checked = false; var first = el.querySelector('input[name="selling_plan"][value=""]'); if (first) first.checked = true; }
          var price = label.querySelector('[data-fa-plan-price]'); if (price && has) price.textContent = money(plans[pid]);
        });
      }
      // theme.js aggiorna l'input "id" sullo stesso evento: aspettiamo il ciclo successivo
      $all('[data-fa-option] input', el).forEach(function (i) { i.addEventListener('change', function () { setTimeout(sync, 0); }); });
      sync();
    });
  }

  /* Prodotti consigliati da Shopify */
  function initRecommendations(root) {
    $all('[data-fa-recommendations]', root).forEach(function (sec) {
      if (!once(sec, 'rec')) return;
      var url = sec.dataset.faRecommendations; if (!url || !window.fetch) return;
      fetch(url).then(function (r) { return r.text(); }).then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-fa-rec-ready]');
        var target = sec.querySelector('[data-fa-rec-inner]');
        if (!fresh || !target) return; // nessun consiglio: resta la collezione di riserva
        target.innerHTML = '';
        target.appendChild(document.importNode(fresh, true));
        $all('.fa-reveal, .fa-grow', target).forEach(function (x) { x.classList.add('is-visible'); });
      }).catch(function () {});
    });
  }

  /* Indirizzi cliente: paese preselezionato e province */
  function initAddressForms(root) {
    $all('[data-fa-country]', root).forEach(function (sel) {
      if (!once(sel, 'country')) return;
      var form = sel.closest('form');
      var prov = form && form.querySelector('[data-fa-province]');
      var wrap = form && form.querySelector('[data-fa-province-wrap]');
      if (sel.dataset.default) {
        $all('option', sel).forEach(function (o) { if (o.value === sel.dataset.default || o.textContent === sel.dataset.default) o.selected = true; });
      }
      function fill() {
        if (!prov) return;
        var opt = sel.options[sel.selectedIndex];
        var list = []; try { list = JSON.parse((opt && opt.getAttribute('data-provinces')) || '[]'); } catch (e) {}
        var cur = prov.dataset.default || prov.value;
        prov.innerHTML = '';
        list.forEach(function (p) { var o = document.createElement('option'); o.value = p[0]; o.textContent = p[1]; if (p[0] === cur || p[1] === cur) o.selected = true; prov.appendChild(o); });
        if (wrap) wrap.hidden = !list.length;
        prov.disabled = !list.length;
      }
      sel.addEventListener('change', function () { prov && (prov.dataset.default = ''); fill(); });
      fill();
    });
  }

  function init(root) {
    initSteppers(root); initAutosubmit(root); initProductExtras(root); initRecommendations(root); initAddressForms(root);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
